// hooks/useMessages.js
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
// import { ROLE, MESSAGE_STATUS } from "~/types/conversation";
// import type { Message } from "~/types/conversation";
import { getDateWithUTCOffset } from "./timezone";

const useMessages = (conversationId: string) => {
  const [messages, setMessages] = useState<any[]>([]);

  const userSendMessage = (content: string) => {
    setMessages((prevMessages) => [
      ...prevMessages,

      {
        id: uuidv4(),
        conversationId,
        content,
        // role: ROLE.USER,
        // status: MESSAGE_STATUS.PENDING,
        created_at: getDateWithUTCOffset(),
      },
    ]);
  };


  return {
    messages,
    userSendMessage
  };
};

export default useMessages;
